export function networkInfo() {
  const info =
    navigator.connection ||
    navigator.mozConnection ||
    navigator.webkitConnection;

  const type = info?.effectiveType;
  const downlink = info?.downlink;
  const rtt = info?.rtt;
  const saveData = info?.saveData;

  return {
    type,
    downlink,
    rtt,
    saveData,
  };
}

export function languageAndTimeZone() {
  return {
    language: navigator.language || navigator.userLanguage,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
}

export function sanitizeSettingsForAnalytics(settings) {
  if (!settings) {
    return {};
  }
  const sanitized = {
    paymentChannel: settings.paymentChannel || undefined,
    paymentMethods: settings.paymentMethods || undefined,
    hasSmartContractData: !!settings.smartContractData,
    smartContractName: settings.smartContractData?.name || undefined,
    hasSmartContractImg: !!settings.smartContractData?.imgUrl,
    hasDefaultValues: !!settings.defaultValues,
    hasTargetAddress: !!settings.defaultValues?.targetAddress?.value,
    targetAddressEditable: settings.defaultValues?.targetAddress?.editable,
    hasPhone: !!settings.defaultValues?.phone?.value,
    phoneEditable: settings.defaultValues?.phone?.editable,
    hasEmail: !!settings.defaultValues?.email?.value,
    emailEditable: settings.defaultValues?.email?.editable,
    hasFiatAmount: !!settings.defaultValues?.fiatAmount,
    fiatAmount: settings.defaultValues?.fiatAmount || undefined,
    defaultPaymentMethods: settings.defaultValues?.paymentMethods || undefined,
    hasCustomColors: !!settings.colors,
    customColors: settings.colors ? Object.keys(settings.colors) : undefined,
    availablePayCurrency: settings.availablePayCurrency || undefined,
    availableReceiveCurrency: typeof settings.availableReceiveCurrency === 'string' 
      ? settings.availableReceiveCurrency 
      : settings.availableReceiveCurrency?.code || undefined,
    availableReceiveCurrencyProtocol: typeof settings.availableReceiveCurrency === 'object'
      ? settings.availableReceiveCurrency?.protocol
      : undefined,
    hasExternalId: !!settings.externalId,
    externalIdType: settings.externalId ? typeof settings.externalId : undefined,
    hasOrderToken: !!settings.orderToken,
    forceNewTransaction: settings.forceNewTransaction || false,
    closeOnSuccess: settings.closeOnSuccess || true,
    hasSignature: !!settings.signature,
    signatureHasLogo: !!settings.signature?.logoUrl,
    signatureHasHref: !!settings.signature?.href,
  };
  return sanitized;
}
